import { STORAGE_KEYS } from '../config/api';
import type { LoginResponse } from './auth.service';

export interface StoredSession extends LoginResponse {
  sessionId: string;
}

const SESSION_KEY = 'auth_session_v1';
const listeners = new Set<() => void>();

export function readSession(): StoredSession | null {
  const stored = localStorage.getItem(SESSION_KEY);
  try {
    if (stored) return JSON.parse(stored) as StoredSession;
    // Совместимость с уже сохранёнными сессиями до обновления приложения.
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    const user = localStorage.getItem(STORAGE_KEYS.USER_INFO);
    return token && refreshToken && user
      ? { token, refreshToken, userInfo: JSON.parse(user), sessionId: refreshToken }
      : null;
  } catch {
    return null;
  }
}

export function writeSession(data: LoginResponse, sessionId = data.refreshToken): StoredSession {
  const session = { ...data, sessionId };
  // Пара токенов записывается одним действием: другая вкладка не увидит смешанную пару.
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  notify();
  return session;
}

export function clearSession(): void {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.USER_INFO);
  localStorage.removeItem(SESSION_KEY);
  notify();
}

export function subscribeSession(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

function notify(): void {
  listeners.forEach(listener => listener());
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', event => {
    if (event.key === null || event.key === SESSION_KEY ||
        Object.values(STORAGE_KEYS).some(key => key === event.key)) notify();
  });
}
